import React from 'react'
import { useState, useEffect } from 'react'
import Table from './Table'
import { useBranchStore, useSectionStore, useUserStore } from '../../stores'
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer, toast } from "react-toastify";
import { Accordion } from "react-bootstrap";
import { useImmer } from 'use-immer';
import { useRef } from 'react';
import { findBatch, handleXhrError } from '../../utils';
import { DateTime } from 'luxon';
import RepeatableTableRows from '../skeletons/RepeatableTableRows';
const MySwal = withReactContent(Swal);
const toastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

const CollapseArcadian = ({ year, children, index, branch }) => {
    const body = useRef(null);
    const scroll = (e) => {
        body.current.scrollIntoView(false);
        console.log(body.current);
    }
    const eoa = branch.eoa.find(e => e.year === parseInt(year));
    const eoaDate = eoa.date;
    const batch = eoa.currentBatch;
    return (
        <Accordion.Item eventKey={index}>
            <Accordion.Header onClick={scroll}><div className='w-100 d-flex justify-content-between pe-4'>
                <div>Year-{year}</div><div>Batch-{batch} ends on {DateTime.fromISO(eoaDate).monthShort}/{DateTime.fromISO(eoaDate).day}</div>
            </div></Accordion.Header>
            <Accordion.Body>
                {children}
            </Accordion.Body>
            <div ref={body}></div>
        </Accordion.Item>)
}
const filterSections = (data, year, sem) => {
    return data.filter(d => d.year == year && d.sem == sem)
}
const YearCollapse = ({ setOpenModal, setOpenDeleteModal, deleteRef, sem, branchId }) => {
    const initSections = useSectionStore((state) => state.initSections);
    // const branchId = useUserStore((state) => state.data.branch._id);
    const sections = useSectionStore((state) => state.sections);
    const setSectionsLoading = useSectionStore(state => state.setSectionsLoading);
    const IsSectionsLoading = useSectionStore(state => state.loading);
    const currentBranch = useBranchStore(state => state.currentBranch);
    const years = currentBranch.years;
    useEffect(() => {
        setSectionsLoading();
        if (!branchId) {
            return;
        }
        window.$.ajax({
            type: "get",
            url: "/api/course/branches/" + branchId,
            xhrFields: {
                withCredentials: true,
            },
            dataType: "json",
            success: (response, textStatus, request) => {
                console.log(response);
                initSections(response.branch.sections, { ...currentBranch });
            },
            statusCode: {

                404: function () {

                    toast.error("page not found", toastOptions);
                },
                400: function (res) {
                    if (!res.responseJSON) {
                        toast.error("Something went wrong...", toastOptions);
                        return;
                    }

                    toast.error(res.responseJSON.message, toastOptions);
                    return;
                },
            },
            headers: {
                "Access-Control-Allow-Credentials": true,
                "Access-Control-Allow-Origin": "",
            },
            error: function (res, textStatus, err) {
                handleXhrError(res, textStatus, err, () => {
                    //   e.target.disabled = false;
                })
            },
        });
    }, [branchId]);
    // fetching data zustand,sections,branch,sem
    if (IsSectionsLoading) {
        return (
            <div className="container p-0">
                <div className='row'><RepeatableTableRows backgroundColor="#bcc6fb" rows={currentBranch.duration} /></div>
            </div>
        )
    }
    return (
        <div>
            {/* <ToastContainer /> */}
            <div className="container p-0">
                <Accordion flush={true}>
                    {years.map((year, index) => {
                        return (
                            <CollapseArcadian branch={currentBranch} index={index} year={year}><Table setOpenModal={setOpenModal} setOpenDeleteModal={setOpenDeleteModal} deleteRef={deleteRef} data={filterSections(sections, year, sem)} /></CollapseArcadian>
                        )
                    })}
                </Accordion>
            </div>
        </div>
    )
}
export default YearCollapse